(function ($) {

    var $btnWrap;
    var $btnFooterWrap;
    var $magazineHeader;
    var $magazineFooter;
    var $title;
    var $tagList;
    var $followCount;
    var $msgBox;
    var $serviceHeader;
    var $window = $(window);
    var $body = $(document.body);
    var _magazineNo;
    var _magazineAddress;
    var _userInfo;
    var _isBrunchBookClosed;
    var _form;
    var _requestList;
    var _bookEvent;
    var _eventMagazineExtras;
    var _preventAllowJoin;
    var _isMobile;

    var _init = function (magazineNo, magazineAddress, options) {
        _magazineNo = magazineNo;
        _magazineAddress = magazineAddress;
        _preventAllowJoin = (options.preventAllowJoin == true);
        _userInfo = {
            isMaster: options.isMaster == true,
            isAuthor: options.isAuthor == true,
            isRequest: options.isRequest == true,
            isSubscribed: options.isSubscribed == true,
            isAllowJoin: options.isAllowJoin == true,
            isDeletable: options.isDeletable == true,
            isWritable: options.isWritable == true,
            firstArticleNo: options.firstArticleNo,
            lastReadArticle: options.lastReadArticle,
            profileId: options.profileId,
            hasArticle: options.hasArticle == true
        };
        _isMobile = options.isMobile;

        _bookEvent = options.bookEvent;
        _isBrunchBookClosed = _bookEvent ? false : true;
        _eventMagazineExtras = options.eventMagazineExtras;

        $serviceHeader = $('.service_header');
        $magazineHeader = $('.magazine_header');
        $magazineFooter = $('.magazine_footer');
        $btnWrap = $('.magazine_util');
        $btnFooterWrap = $('.magazine_subscription');
        $title = $magazineHeader.find('.tit_subject');
        $tagList = $magazineHeader.find('.magazine_tag_list');
        $followCount = $magazineHeader.find('.magazine_follow_count');

        $window.on('scroll', onWindowScroll);
        $body.on('click', function (e) {
            _hideMenu();
        });

        $body.on('click', 'a>.btn_write', function (e) {
            e.stopPropagation();
            e.preventDefault();
            window.location.href = '/write?magazineNo=' + _magazineNo;
        });

        $magazineHeader.on('click', _actionHandler);
        $magazineFooter.on('click', _actionHandler);

        _refreshBtnWrap();

        if (_userInfo.isMaster && location.hash == '#requests') {
            _showRequest();
        }

    };

    var onWindowScroll = function (e) {
        var top = $window.scrollTop();
        var padding = $magazineHeader.height() + 130;
        var className = 'beyond_content';

        if (top > padding) {
            $serviceHeader.addClass(className);
        } else {
            $serviceHeader.removeClass(className);
        }
    };

    var _actionHandler = function (e) {
        var $btn = _getActionButton(this, e.target);
        var action = $btn.data('action');

        if (!action) {
            return;
        }

        e.preventDefault();
        e.stopPropagation();

        if (action == 'menu') {
            _toggleMenu();
        } else {
            _hideMenu();

            if (action == 'edit') {
                _edit();
            } else if (action == 'stat') {
                document.location.href = '/magazine/' + _magazineAddress + '/stats';
            } else if (action == 'quit') {
                _exitMagazine();
            } else if (action == 'manageAuthor') {
                _showAuthor(true);
            } else if (action == 'manageRequest') {
                _showRequest();
            } else if (action == 'cancelRequest') {
                _cancelAuthorRequest();
            } else if (action == 'sendRequest') {
                _sendAuthorRequest();
            } else if (action == 'follow') {
                _follow();
            } else if (action == 'unfollow') {
                _unfollow();
            } else if (action == 'followerList') {
                _showFollower();
            } else if (action == 'authorList') {
                _showAuthor(false);
            }
        }
    };

    var _toggleMenu = function () {
        $btnWrap.toggleClass('util_open');
    };

    var _hideMenu = function () {
        $btnWrap.removeClass('util_open');
    };
    var _showMenu = function () {
        $btnWrap.addClass('util_open');
    };

    var _edit = function () {
        _showForm();
    };

    var _showForm = function () {
        var layer = B.Util.layer.showLayerBase();

        if (!_form) {
            _form = B.Magazine.Form;

            if (_form) {
                _form.init({
                    container: layer,
                    isBrunchBookClosed: _isBrunchBookClosed,
                    magazine: _makeOriginalMagazine(_eventMagazineExtras),
                    successHandler: function (magazine, createMore, totalCount, extras) {
                        $title.text(magazine.title);
                        $tagList.children().remove();
                        for (var i = 0; i < magazine.tagList.length; i++) {
                            var tagName = magazine.tagList[i].name;
                            $tagList.append("<a href='/search/magazine/tag/" + tagName + "' class='link_tag'>" + tagName + '</a>');
                        }

                        _userInfo.isAllowJoin = magazine.allowJoin;
                        _eventMagazineExtras = extras;
                        _refreshBtnWrap();
                        _hideForm();
                    },
                    failHandler: function () {
                        _hideForm();
                    },
                    bookEvent: _bookEvent
                });
            }
        } else {
            _form.initForm(_makeOriginalMagazine(_eventMagazineExtras));
        }

        _form.show();
    };
    var _hideForm = function () {
        _form.hide();
        B.Util.layer.hideLayerBase();
    };

    var _exitMagazine = function () {
        var message;

        if (_userInfo.isMaster) {
            if (_userInfo.isDeletable) {
                message = '매거진 삭제 시 5일 이내에는 동일한 주소로 매거진을 만드실 수 없습니다. 계속 진행하시겠습니까?';
            } else {
                message = '아직 참여 중인 다른 작가가 있기 때문에 매거진은 삭제되지 않습니다.\n또한 매거진 탈퇴 시, 다른 작가에게 관리 권한이 양도됩니다.\n매거진에서 정말 탈퇴하시겠습니까?';
            }
        } else {
            message = '탈퇴 시 기존에 매거진으로 발행한 글은 매거진에서 모두 제외됩니다. 매거진에서 탈퇴하시겠습니까?';
        }

        B.Util.confirm(message, function (isOk) {
            if (isOk) {
                $.ajax({
                    url: B.Config.apiUrl + '/v1/magazine/' + _magazineNo + '/author/' + B.User.userId,
                    method: 'DELETE',
                    xhrFields: {
                        withCredentials: true
                    }
                }).done(function (data) {
                    if (_userInfo.isMaster && _userInfo.isDeletable) {
                        document.location.href = '/@' + B.User.profileId + '/magazines';
                    } else {
                        _userInfo.isAuthor = false;
                        _userInfo.isMaster = false;
                        _refreshBtnWrap();
                    }
                }).fail(function () {
                    _showMessage('오류가 발생했습니다.');
                });
            }
        });
    };

    var _showAuthor = function (isManage) {
        B.Magazine.Author.show(_magazineNo, _magazineAddress, isManage);
    };

    var _showRequest = function () {
        B.Magazine.Request.show(_magazineNo);
    };

    var _showFollower = function () {
        B.Magazine.Follower.show(_magazineNo, $followCount.text());
    };

    var _getShareMagazine = function () {
        var magazine = _makeOriginalMagazine();

        return {
            prefix: magazine.title + ' 매거진',
            link: B.Config.serviceUrl + '/magazine/' + magazine.magazineAddress,
            description: 'by ' + jQuery('meta[name=byl]').attr('content'),
            image: {
                src: 'https://t1.daumcdn.net/thumb/C720x360/?fname=' + encodeURIComponent('http://t1.daumcdn.net/brunch/static/img/help/pc/img_share_magazine_800_2.png'),
                width: 380,
                height: 190
            },
            appContext: B.webToApp({ flag: 'magazine', magazineNo: magazine.magazineNo }, true),
            layerDesc: '브런치 매거진을<br>SNS에 공유해보세요.',
            shareTiaraId: '#share'
        };
    };

    var _cancelAuthorRequest = function () {
        B.Util.confirm('아직 매거진 참여 신청이 확인되지 않은 상태입니다.\n참여 신청을 취소하시겠습니까?', function (isOk) {
            if (isOk) {
                B.Util.ajax({
                    url: B.Config.apiUrl + '/v1/magazine/' + _magazineNo + '/author/request',
                    method: 'DELETE',
                    success: function (data) {
                        _userInfo.isRequest = false;
                        _refreshBtnWrap();
                    }
                });
            }
        });
    };

    var _sendAuthorRequest = function () {
        B.Util.confirm('참여작가가 되면 이 매거진에 함께 글을 보낼 수 있습니다.\n매거진 참여를 신청하시겠습니까?', function (isOk) {
            if (isOk) {
                B.Util.ajax({
                    url: B.Config.apiUrl + '/v1/magazine/' + _magazineNo + '/author/request',
                    method: 'POST',
                    data: {
                        request: 'request' // dummy
                    },
                    success: function (data) {
                        var status = data.data.status;

                        if (status == 'REQUEST') {
                            _userInfo.isRequest = true;
                        } else if (status == 'ACCEPTED') {
                            _userInfo.isAuthor = true;
                        }

                        _refreshBtnWrap();
                    },
                    error: function (data) {
                        if (data.responseText != undefined) {
                            var d = JSON.parse(data.responseText);

                            if (d.code == 904) {
                                alert(d.desc);
                                return true;
                            }
                        }
                    }
                });
            }
        });

    };

    var _addCount = function (cnt, addValue) {
        cnt = cnt.replace(/,/g, '');

        if (isNaN(cnt)) {
            return 0;
        }

        var cnt = new Number(cnt);
        cnt += addValue;
        return cnt.toLocaleString();
    };

    var _follow = function () {
        B.Util.ajax({
            url: B.Config.apiUrl + '/v1/subscription/magazine/follow',
            method: 'POST',
            data: {
                magazineNo: _magazineNo
            },
            success: function (data) {
                _userInfo.isSubscribed = true;
                var cnt = _addCount($followCount.text(), 1);
                $followCount.text(cnt);
                _refreshBtnWrap();

                if (_isMobile) {
                    B.M.postFollowMagazine();
                }

                T.newClick()
                    .setName('개별 일반 매거진 뷰 > 구독 버튼 클릭')
                    .setActionKind('Follow')
                    .setLayer1('follow_magazine')
                    .track();
            }
        });
    };

    var _unfollow = function () {
        B.Util.ajax({
            url: B.Config.apiUrl + '/v1/subscription/magazine/unfollow/' + _magazineNo,
            method: 'DELETE',
            success: function (data) {
                _userInfo.isSubscribed = false;
                var cnt = _addCount($followCount.text(), -1);
                $followCount.text(cnt);
                _refreshBtnWrap();

                T.newClick()
                    .setName('개별 일반 매거진 뷰 > 구독 버튼 클릭')
                    .setActionKind('Follow')
                    .setLayer1('unfollow_magazine')
                    .track();
            }
        });
    };

    var _makeOriginalMagazine = function (extras) {
        var tagList = [];
        $tagList.find('a').each(function (index, elm) {
            tagList.push($(elm).text());
        });

        var magazine = {
            title: $title.text(),
            magazineNo: _magazineNo,
            magazineAddress: _magazineAddress,
            tagList: tagList,
            allowJoin: _userInfo.isAllowJoin ? '1' : '',
            preventAllowJoin: _preventAllowJoin
        };

        if (extras && extras.bookCategory) {
            magazine['bookCategory'] = extras.bookCategory;
        }

        return magazine;
    };

    var _getActionButton = function (container, target) {
        var btn = $(target);
        while (!btn.is(container) && !btn.data('action')) {
            btn = btn.parent();
        }

        return btn;
    };

    var _refreshBtnWrap = function () {
        var templateData = $.extend({
            isMobile: _isMobile
        }, _userInfo);
        $btnWrap.html(B.Util.getTemplate('magazine-btn.hbs', templateData));
        $btnFooterWrap.html(B.Util.getTemplate('magazine-footer-btn.hbs', templateData));
    };

    var _initPcShare = function () {
        var context = _getShareMagazine();
        context.image = JSON.stringify(context.image);
        context.appContext = JSON.stringify(context.appContext);
        jQuery('.magazine_sns').append(B.Util.getTemplate('common-share-pc-btns.hbs', context));
        $('.magazine_sns').on('click', 'button', $.proxy(B.Util.socialShare.share, B.Util.socialShare));
    };

    B.Magazine = $.extend(B.Magazine, {
        init: function (magazineNo, magazineAddress, options) {
            _init(magazineNo, magazineAddress, options || {});
        },
        initLayer: function () {
            var $openEl = jQuery('a.detail_share[data-action=socialShare]');
            B.M.socialShareService.initLayer.handler($openEl, _getShareMagazine());
        },
        initPcShare: function () {
            _initPcShare();
        }
    });

})(jQuery);
